export const enum ScheduleTab {
  InProgress = 1,
  Scheduled = 2,
}

export const SCHEDULE_TAB_STORAGE_KEY = 'schedule-orders-tab';

export const SCHEDULED_ORDERS_STALE_TIME_MS = 60_000;

export const SCHEDULED_ORDER_DETAIL_STALE_TIME_MS = 60_000;

export const SCHEDULED_ORDER_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const SCHEDULED_ORDER_MERIDIEM = Object.freeze({
  am: 'a.m.',
  pm: 'p.m.',
});
